import { AjvError } from "@rjsf/core";
import { forEachSchemaProp } from "./forEachSchemaProp";
import { IFormSchema } from "../models/IFormSchema";


export const transformHeaderErrors = (schema: IFormSchema["schema"], errors: Array<AjvError>): Array<AjvError> => {

    let paths: string[] = [];

    forEachSchemaProp(schema.properties, (path, property) => {
        if ((property as any).type === "header") {
            paths = paths.concat(path);
        }
    });

    errors = errors.filter((error) => {
        const header = paths.find((path) => error.property.indexOf(path) > -1);
        return !header;
    });

    return errors;

};